import { render, staticRenderFns } from "./ticketComponent.vue?vue&type=template&id=deff0dc2"
import script from "./ticketComponent.vue?vue&type=script&lang=js"
export * from "./ticketComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports